import { SocialsPlatformServiceName } from "@bluframe/mightychroma-mightytool-frontend-types"

export const socialsPlatformServiceNameLabels: Record<
  SocialsPlatformServiceName,
  string
> = {
  blueSky: "Blue Sky",
  facebook: "Facebook",
  instagram: "Instagram",
  threads: "Threads",
  twitterX: "X"
}
